import { FaClock, FaChartLine, FaBookOpen, FaMoneyBill, FaHandsHelping, FaArrowUp, FaCoffee, FaUserPlus, FaCogs, FaUtensils, FaShieldAlt } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Become a Part of Our Coffee Family",
    description: "At Brewtopia, we are passionate about coffee and delivering an exceptional customer experience. We're always looking for enthusiastic and talented individuals to join our team. Whether you're a seasoned barista, we offer exciting career opportunities in a dynamic and supportive environment.",
    points: [
        {
            icon: <FaCoffee />,
            title: "Barista and Coffee Expert Positions",
        },
        {
            icon: <FaUserPlus />,
            title: "Opportunities for Career Growth and Training",
        },
        {
            icon: <FaCogs />,
            title: "Learn the Art of Craft Coffee and Brewing Techniques",
        },
        {
            icon: <FaUtensils />,
            title: "Work in a Collaborative, Friendly Team Environment",
        },
        {
            icon: <FaShieldAlt />,
            title: "Emphasis on Safety and Cleanliness Standards",
        },
    ],
};

const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Advancement",
        description: "Explore exciting opportunities for career growth within the coffee industry. As a barista or team member, there's plenty of room to grow.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Training Programs",
        description: "Participate in hands-on training to master coffee brewing techniques and customer service skills. Learn about different coffee beans and brewing methods.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description: "Enjoy good pay and benefits, with opportunities for tips. We value our team and reward hard work with attractive compensation packages.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description:
        "Our flexible schedule accommodates your personal lifestyle. Whether part-time or full-time, we’ll create a schedule that fits.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Collaboration",
        description: "Work alongside a passionate and friendly team. At Brewtopia, we foster a positive environment where everyone contributes ideas.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Growth Potential",
        description: "We believe in nurturing talent from within. With plenty of advancement opportunities, you can grow into leadership roles like shift supervisor.",
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Barista',
        details: {
            location: 'Café Name, City',
            timing: 'Full Time',
            hours: 'Shifts, Flexible Hours',
            experience: 'Previous Barista experience preferred but not required',
            position: 'Multiple Positions Available',
            days: 'Flexible Shifts, Including Weekends',
            salary: '$35K - $45K',
            deadline: 'Apply Now - Positions Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'We are seeking an enthusiastic and experienced Barista to join our team. As a Barista, you will be responsible for preparing and serving high-quality coffee beverages, creating an inviting atmosphere for our customers, and delivering exceptional customer service. If you\'re passionate about coffee and creating great experiences for others, we would love to hear from you!',
        ],
        responsibilities: [
            'Preparing and serving coffee, espresso drinks, and other beverages to customers.',
            'Engaging with customers to take orders and make recommendations based on their preferences.',
            'Maintaining a clean and organized workspace, including coffee machines and equipment.',
            'Ensuring the café environment is warm, welcoming, and conducive to a great customer experience.',
            'Operating the cash register and handling payments accurately.',
            'Managing inventory of coffee supplies and ensuring freshness of ingredients.',
        ],
        qualifications: [
            'Previous experience as a Barista or in a customer-facing role (preferred but not required).',
            'Passion for coffee and a desire to learn about different brewing techniques and beverages.',
            'Excellent communication skills and the ability to interact with customers in a friendly and professional manner.',
            'Ability to work in a fast-paced environment while maintaining attention to detail.',
            'A positive attitude, team spirit, and the ability to collaborate with colleagues.',
            'Ability to work early mornings, weekends, and holidays as needed.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Café Manager',
        details: {
            location: 'Café Name, City',
            timing: 'Remote',
            hours: 'Shifts, Flexible Hours',
            experience: 'Experience in café or restaurant management preferred',
            position: 'One Position Available',
            days: 'Weekdays and Weekends',
            salary: '$50K - $60K',
            deadline: 'Apply Now - Positions Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'We are looking for an experienced and motivated Café Manager to lead our team and oversee daily operations. The ideal candidate is passionate about hospitality, has strong leadership skills, and is committed to creating a welcoming environment for both customers and staff.',
        ],
        responsibilities: [
            'Overseeing daily operations of the café, including opening and closing procedures.',
            'Supervising and supporting staff to ensure efficient service and high morale.',
            'Monitoring inventory and placing orders for supplies as needed.',
            'Ensuring adherence to health, safety, and cleanliness standards.',
            'Managing schedules, payroll, and budgeting tasks.',
            'Handling customer inquiries, feedback, and complaints professionally.',
        ],
        qualifications: [
            'Proven experience as a café manager or similar hospitality role.',
            'Strong leadership, organizational, and multitasking skills.',
            'Excellent interpersonal and communication abilities.',
            'Familiarity with point-of-sale (POS) systems and staff management tools.',
            'Ability to manage time efficiently and delegate tasks effectively.',
            'Flexibility to work on weekends and holidays if required.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Coffee Roaster',
        details: {
            location: 'Café Name, City',
            timing: 'Full Time',
            hours: 'Day Shifts, Early Mornings Preferred',
            experience: 'Experience with commercial coffee roasting equipment preferred',
            position: 'One Position Available',
            days: 'Monday to Friday',
            salary: '$40K - $50K',
            deadline: 'Apply Now - Positions Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'We are on the lookout for a passionate Coffee Roaster to join our café’s roasting team. This role involves selecting high-quality beans, roasting with precision, and contributing to the unique flavor profile of our signature blends. Ideal for someone who loves coffee science and craftsmanship.',
        ],
        responsibilities: [
            'Operating coffee roasting machines and monitoring roast profiles.',
            'Tasting and evaluating coffee batches for quality and consistency.',
            'Maintaining roasting logs and documentation.',
            'Packaging roasted coffee and managing inventory.',
            'Cleaning and maintaining roasting equipment.',
            'Collaborating with the café team to align flavor profiles with menu offerings.',
        ],
        qualifications: [
            'Experience with coffee roasting equipment and processes.',
            'Strong understanding of green coffee sourcing and flavor development.',
            'Attention to detail and a commitment to consistency.',
            'Ability to lift heavy bags of coffee and stand for extended periods.',
            'Passion for specialty coffee and continued learning.',
            'Good communication and teamwork skills.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Dishwasher',
        details: {
            location: 'Café Name, City',
            timing: 'Part Time',
            hours: 'Evening and Weekend Shifts',
            experience: 'No prior experience required, training provided',
            position: 'Multiple Positions Available',
            days: 'Flexible Schedule, Including Weekends',
            salary: '$15K - $20K',
            deadline: 'Apply Now - Positions Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'We are hiring a reliable and efficient Dishwasher to support our kitchen operations. As a Dishwasher, you will ensure cleanliness and organization in the kitchen, playing a vital role in keeping the café running smoothly. If you’re detail-oriented and enjoy working behind the scenes, we’d love to hear from you.',
        ],
        responsibilities: [
            'Washing dishes, utensils, and kitchen equipment promptly and thoroughly.',
            'Maintaining cleanliness in the dishwashing and kitchen area.',
            'Emptying trash and cleaning floors in dish and prep areas.',
            'Restocking clean dishes and supplies to proper locations.',
            'Assisting kitchen staff with basic prep or cleaning tasks as needed.',
            'Following all sanitation and safety guidelines.',
        ],
        qualifications: [
            'Ability to work in a fast-paced environment.',
            'Good physical stamina and ability to stand for long periods.',
            'Attention to cleanliness and detail.',
            'Positive attitude and teamwork mindset.',
            'Willingness to take direction and learn.',
            'Flexibility to work weekends and holidays.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Service Specialist',
        details: {
            location: 'Café Name, City',
            timing: 'Full Time',
            hours: 'Rotational Shifts, Morning to Evening',
            experience: 'Customer service experience preferred',
            position: 'Multiple Positions Available',
            days: '5 Days a Week, Including Weekends',
            salary: '$30K - $40K',
            deadline: 'Apply Now - Positions Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'We’re on the lookout for a friendly and professional Service Specialist to be the face of our café. In this role, you’ll ensure that customers feel welcomed, orders are taken accurately, and service is prompt and cheerful. If you enjoy engaging with people and delivering standout service, this could be the perfect role for you.',
        ],
        responsibilities: [
            'Greeting and assisting customers in a warm and friendly manner.',
            'Taking customer orders and ensuring accuracy in processing.',
            'Serving food and beverages efficiently and politely.',
            'Maintaining cleanliness and organization in the service area.',
            'Handling customer feedback and resolving minor issues.',
            'Collaborating with the kitchen and barista teams for smooth service.',
        ],
        qualifications: [
            'Strong communication and interpersonal skills.',
            'Previous experience in customer service or hospitality (preferred).',
            'Ability to multitask in a busy environment.',
            'A team-oriented mindset and a positive attitude.',
            'Basic math skills for handling payments if needed.',
            'Willingness to work on weekends and holidays.',
        ],
    }

];

export { positions, benefits, careerIntro };